import React, { useRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import contriesList from "iso-3166-1-alpha-2";
import { RegexFields } from "../../../../../../constants/utils/regexFields";
import * as R from "ramda";
import $ from "jquery";
import * as loadings from "../../../../../../constants/loadings/facilita/deathDeclaration";
import { createServiceData, updateServiceData, deleteServiceData } from "../../../../../../actions/facilita-api";
import { ConnectionTypes } from "../../../../../../constants/utils/connectionTypes";

import { PostalCityInput } from "../../../../../../_common/postalCityInput";

export const ModalOtherActivitySection = ({ activity, initCollapsedState, index, isLoading, removeFromList }) => {
	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	let initState = {
		...activity.payload,
	};
	initCollapsedState = R.isNil(activity.collapsed) ? initCollapsedState : activity.collapsed;

	const activityForm = useRef(null);
	const [wasValidated, setWasValidated] = useState(false);
	const [payload, setPayload] = useState(initState);
	const [collapsed, setCollapsed] = useState(initCollapsedState);

	let hasCompanySavingsPlanReference = false;
	if (!R.isNil(payload.companySavingsPlanReference) && payload.companySavingsPlanReference !== "") {
		hasCompanySavingsPlanReference = true;
	}

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	return (
		<section className={"block mb-3"} id={"otherActivity_" + index}>
			<div className="card-header p-0 mb-3" id={"otherActivity_" + index + "_heading"} role="button" onClick={() => setTimeout(() => setCollapsed(!collapsed), 200)}>
				<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#ModalOtherActivitySection_" + index} aria-expanded={!collapsed} aria-controls={"#ModalActivitySection_" + index}>
					<h4 className="h3 font-weight-black container-tight my-auto">Autre activité</h4>
					{!R.isNil(payload.name) ? (
						<span className="mr-auto align-middle">
							<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
							<span className="o-60 align-middle">{payload.name}</span>
						</span>
					) : (
						""
					)}
					<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
						<i className={"eva " + (!collapsed ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
					</button>
				</div>
			</div>
			<div className={"collapse" + (collapsed ? " show" : "")} id={"ModalOtherActivitySection_" + index} aria-labelledby={"otherActivity_" + index + "_heading"} data-parent={"#otherActivity_" + index}>
				<form className="block" noValidate ref={activityForm}>
					<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm">nom de l’entreprise</h5>
					<div className="row gx-2 mt-n2">
						<div className="col-12 col-md-5">
							<div className="form-group">
								<label className="h6 font-weight-bolder my-auto" htmlFor={"otherActivity_name" + index}>
									Intitulé de l'activité
								</label>
								<input required type="text" className="form-control" id={"otherActivity_name" + index} placeholder="ex: association, bénévola" value={payload.name} onChange={(e) => setPayload({ ...payload, name: e.target.value })} />
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
						</div>
						<div className="col-12 col-md-7">
							<div className="form-group">
								<div className="flex-row gx-2 align-items-center mb-1">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"otherActivity_Address_line1_" + index}>
										Adresse ligne 1
									</label>
									<p
										className="form-text small text-gray my-auto ml-auto"
										data-toggle="tooltip"
										data-placement="top"
										data-html="true"
										data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
										title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
										<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
									</p>
								</div>
								<input required type="text" className="form-control" id={"otherActivity_Address_line1_" + index} placeholder="Adresse de l'organisme" value={payload.address.streetAddress} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress: e.target.value } })} />
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
							<div className="form-group">
								<label className="label h6 font-weight-bold my-auto" htmlFor={"otherActivity_Address_line2_" + index}>
									Adresse ligne 2
								</label>
								<input type="text" className="form-control rounded" id={"otherActivity_Address_line2_" + index} placeholder="(optionnel)" value={payload.address.streetAddress2} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress2: e.target.value } })} />
							</div>
							<div className="form-row">
								<PostalCityInput
									postalCode={payload.address.postalCode}
									city={payload.address.addressLocality}
									onChange={(updatedAddress) => setPayload({ ...payload, address: { ...payload.address, postalCode: updatedAddress.postalCode, addressLocality: updatedAddress.city } })}
									hasWrapper={false}
									country={payload.address.addressCountry}
									customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
								/>
								{/* <div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"otherActivity_Address_zipcode_" + index} required>
											Code Postal
										</label>
										<input required type="text" className="form-control" id={"otherActivity_Address_zipcode_" + index} placeholder="ex: 75001" value={payload.address.postalCode} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, postalCode: e.target.value } })} />
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div>
									<div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"otherActivity_Address_locality_" + index} required>
											Ville
										</label>
										<input required type="text" className="form-control" id={"otherActivity_Address_locality_" + index} placeholder="ex: Paris" value={payload.address.addressLocality} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressLocality: e.target.value } })} />
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div> */}
								<div className="form-group col-12 col-sm-6 col-lg">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"otherActivity_Address_country_" + index}>
										Pays
									</label>
									<select className="custom-select" id={"otherActivity_Address_country_" + index} value={payload.address.addressCountry} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressCountry: e.target.value } })}>
										{Object.keys(contriesList.getData()).map((country, idx) => {
											return (
												<option key={idx} value={country}>
													{countries.getName(country, "fr", { select: "official" })}
												</option>
											);
										})}
									</select>
								</div>
							</div>
						</div>
					</div>
					<hr className="mb-gutter" />
					<div className="row gx-2 mt-n2">
						<div className="col-12 col-md">
							<div className="form-group">
								<label className="h6 font-weight-bolder my-auto" htmlFor={"otherActivity_function_" + index}>
									Intitulé du poste
								</label>
								<input required type="text" className="form-control" id={"otherActivity_function_" + index} placeholder="ex: Trésorier d'association, formateur..." value={payload.function} onChange={(e) => setPayload({ ...payload, function: e.target.value })} />
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
						</div>
					</div>

					<hr className="my-0" />
					<div className="card-footer text-right px-0">
						{isLoading.includes(loadings.UPDATING_USER_SERVICES_DATA + "_" + activity.id) || isLoading.includes(loadings.CREATING_USER_SERVICES_DATA + "_" + activity.serviceId) ? (
							<button type="button" className="btn btn-info loading-btn show">
								<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder
							</button>
						) : (
							<button
								type="button"
								className="btn btn-info"
								onClick={(e) => {
									e.preventDefault();
									activityForm.current.classList.add("was-validated");
									if (activityForm.current.checkValidity()) {
										if (R.isNil(activity.id) || activity.id === "") {
											dispatch(
												createServiceData({
													...activity,
													payload: payload,
												})
											).then(() => setCollapsed(!collapsed));
										} else {
											dispatch(
												updateServiceData({
													...activity,
													payload: payload,
												})
											).then(() => setCollapsed(!collapsed));
										}
										setCollapsed(!collapsed);
									}
								}}>
								Enregistrer
							</button>
						)}
						<button
							className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
							id="basic-addon2"
							onClick={(e) => {
								e.preventDefault();
								if (R.isNil(activity.id)) {
									removeFromList(index);
								} else {
									dispatch(deleteServiceData(activity.id, ConnectionTypes.activity));
								}
							}}>
							<i className="eva eva-trash-outline"></i>
						</button>
					</div>
				</form>
			</div>
		</section>
	);
};
